/* eslint-disable */
// setShareConfig({
//     title: info.skuName,
//     desc: info.promotion,
//     link: info.brief,
//     images: info.imageInfos
// }
import env from './clientEnv'
import API from 'api'

// const qqopenshareapi = '//qzonestyle.gtimg.cn/qzone/qzact/common/share/share.js'
// var qqopenshareapi = '/assets/js/plugins/tencent/share.js?t=16'

// 资源是否下载完成，如果已经下载过，则不会重复下载
var downloadState = {}

var shareInfo = {}

function _require(url, onload) {
  // 如果该资源已下载，则直接执行onload
  if (downloadState[url]) {
    return onload()
  }
  var script = document.createElement('script')
  script.async = true
  script.onload = function () {
    // 将该资源下载状态标识为已下载，不再重复下载
    downloadState[url] = true
    onload()
  }
  script.src = url
  document.getElementsByTagName('script')[0].parentNode.appendChild(script)
}

function _normalize(params) {
  var t = params || {}

  return {
    title: t.title || document.title || '',
    weiTitle: t.desc || $('meta[name=description]').attr('content') || document.title || '',
    weiLink: t.link || location.href,
    weiImg: ((t.images || [])[0] || {}).smallPic || '',
    miniImg: ((t.images || [])[0] || {}).bigPic || '',
  }
}

/**
 * 初始化分享参数
 * @param shareOption Object
 * title，desc，link，images
 */
function setShareConfig(shareOption) {
  const param = _normalize(shareOption)
  param.miniPath = shareOption.miniPath
  // wxfriend（微信好友）、wxspace（微信朋友圈）
  // 6750版本新增，分享朋友圈/微信好友 数据与其他渠道存在差异
  shareInfo.wxspace = { ...param }
  shareInfo.wxfriend = shareOption.wxfriend ? { ...param, ...shareOption.wxfriend } : { ...param }
  //qqspace(qq朋友圈)、qqfriend(qq好友)、 weibo（微博）、sms（短信）、email（电子邮件）、copy（复制链接）数据基本一致
  shareInfo.qqspace =
  shareInfo.qqfriend =
  shareInfo.weibo = { ...param }
  shareInfo.sms =
    shareInfo.email =
  shareInfo.copy = { ...param, ...shareOption.copy }

  shareInfo.dialogAdvTitle = shareOption.dialogAdvTitle
  shareInfo.dialogAdvContent = shareOption.dialogAdvContent
  // 6300版本新增，用于App分享弹层上自定义的图片
  if (shareOption.dialogAdvImg) {
    shareInfo.dialogAdvImg = shareOption.dialogAdvImg
    shareInfo.dialogAdvImgJump = shareOption.dialogAdvImgJump
  } else {
    shareInfo.dialogAdvImg = ''
    shareInfo.dialogAdvImgJump = ''
  }
  // 适配pad折叠屏分享
  shareInfo.dialogCustomTitle = shareOption.dialogCustomTitle
  shareInfo.dialogCustomContent = shareOption.dialogCustomContent
  shareInfo.dialogCustomContentJump = shareOption.dialogCustomContentJump
  // 6750版本新增，用于APP分享海报图展示
  shareInfo.posterLargeImg = shareOption.posterLargeImg
  shareInfo.sharePosterToSpaceFlag = shareOption.sharePosterToSpaceFlag
  shareInfo.weiboChannelShow = shareOption.weiboChannelShow
  shareInfo.downloadChannelShow = shareOption.downloadChannelShow
  shareInfo.shareFrom = shareOption.shareFrom || '' // 商详页：sku, 推荐活动：recommend, 订单详情：order, 其他传''
  shareInfo.shareSKUId = shareOption.shareSKUId || '' // 商详页传skuId， 非商详页传空
  // 分享title图片变更为多个配置适配
  shareInfo.dialogAdvIcon = shareOption.dialogAdvIcon // 悬浮活动图片
  shareInfo.dialogAdvTextColor = shareOption.dialogAdvTextColor // 文案颜色
  shareInfo.dialogAdvBg = shareOption.dialogAdvBg // 利益条底色

  // 调用分享接口
  if (env.isVivoApp) {
    _callVivospaceShareApi()
  } else if (env.isWx || env.isQQ) {
    _callQQOpenShareApi()
  }
}

// 调用腾讯对外分享接口
function _callQQOpenShareApi() {
  // _require(qqopenshareapi, function () {
  var lsi = (env.isWx ? shareInfo.wxspace : shareInfo.qqspace) || {}
  var sp = {
    title: lsi.title,
    summary: lsi.weiTitle,
    pic: lsi.weiImg,
    url: lsi.weiLink
  }
  if (env.isWx) {
    // 获取微信接口调用签名信息
    API.getWXConfig(location.href.split('#')[0]).then(res => {
      let wxc = res.weiChatConfig || {}
      sp.WXconfig = {
        swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
        appId: wxc.appId, // 公众号的唯一标识
        timestamp: wxc.timestamp, // 生成签名的时间戳
        nonceStr: wxc.nonceStr, // 生成签名的随机串
        signature: wxc.signature, // 签名
        jsApiList: ['checkJsApi'],
        openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      }
      window.setShareInfo(sp)
    })
  } else {
    window.setShareInfo(sp)
  }
  // })
}
// 设置 VIVO 官网APP分享接口参数
function _callVivospaceShareApi() {
  if (typeof window.vivospace.setShareChannelData === 'function') {
    // 使用多渠道分享
    window.vivospace.setShareChannelData(JSON.stringify(shareInfo))
  } else {
    var sif = shareInfo.wxspace || {}

    var html = '<meta name="weiTitle" content="' + sif.weiTitle + '">'
    html += '<meta name="weiImg" content="' + sif.weiImg + '">'
    html += '<meta name="weiLink" content="' + sif.weiLink + '">'

    if (typeof window.vivospace?.showSource === 'function') {
      // 调用客户端接口设置分享参数
      window.vivospace?.showSource(html)
    }
  }
}

export default setShareConfig
